import { ROUTES } from '#/config/routes';

/** 倉別管理 hub 導覽卡 */
const storePlaceMgmtNavigate = [
  {
    to: ROUTES.storePlaceWarehouse,
    title: '倉別列表',
    subtitle: '管理倉別主檔',
  },
  {
    to: ROUTES.storePlaceLocation,
    title: '儲位列表',
    subtitle: '管理倉別下的儲位',
  },
];

export default storePlaceMgmtNavigate;
